export const getTwoChars = (fullName: string): string => {
  if (!fullName)
    return "אב";
  const splitName = fullName.split(" ");
  if (splitName.length > 1) {
    const firstChars = splitName.map((name) => name[0]).join('');
    return firstChars.substring(0, 2);
  }
  return fullName.substring(0, 2);
}

export const formatPhoneByDelimiters = (phoneNumber: string, addDelimiter = false): string => {
  if (!phoneNumber)
    return ""
  if (addDelimiter)
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`
  return phoneNumber;
}

export const cleanPhoneNumber = (phone: string) => {
  return phone?.replace(/\D+/g, '');
}

export const cleanPhoneNumberComplete = (phone: string) => {
  let cleanPhoneNumber = phone?.replace(/\D+/g, '');
  if (cleanPhoneNumber.startsWith('972'))
    cleanPhoneNumber = cleanPhoneNumber.replace('972', '0');

  console.log(`${phone} => ${cleanPhoneNumber}`)
  return cleanPhoneNumber;
}


export const formatNumber = (phone: string): string => {
  let formattedPhone = phone?.replace(/\D+/g, '');
  if (formattedPhone.length === 10 && formattedPhone.startsWith('0'))
    formattedPhone = formattedPhone.substring(1);
  if (formattedPhone.length === 9)
    formattedPhone = `972${formattedPhone}`;

  return formattedPhone;
}
